<style lang="less" scoped>
  @import "../../../style/theme.less";

</style>

<template>
  <div>
    <a-page-header
      title="Normalisation Vectors"
      style="padding: 0; margin-bottom: 8px"
    >
      <template slot="extra">
        <a-button type="primary" shape="circle" icon="reload" @click="() => listNormalisationVectors()"/>
      </template>
    </a-page-header>

    <a-table
      :columns="columns"
      :data-source="formattedNormalisationVectors"
      :pagination="false"
      :rowKey="({ id }) => id"
    >

      <span slot="gender" slot-scope="data">{{ constants.genders.genderDescriptors[data] || data | capitalise }}</span>

      <a-button
        slot="details"
        slot-scope="record"
        type="primary"
        shape="circle"
        icon="setting"
        @click="() => $router.push({ name: 'admin.normalisation-vectors.details', params: { id: record.id }})"/>
    </a-table>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  }, {
    title: 'Gender',
    dataIndex: 'gender',
    scopedSlots: { customRender: 'gender', },
  }, {
    title: 'Age',
    dataIndex: 'age',
  }, {
    width: '100px',
    align: 'center',
    scopedSlots: { customRender: 'details', },
  },
];

export default {
  name: 'admin.normalisation-vectors',

  data: () => ({
    columns,
  }),

  mounted() {
    return Promise.all([
      this.listNormalisationVectors(),
      this.listConstants(),
    ]);
  },

  computed: {
    ...mapState('admin', ['normalisationVectors', 'constants',]),

    formattedNormalisationVectors() {
      if (!this.normalisationVectors) {
        return [];
      }

      return this.normalisationVectors.map(({ id, condition: { conditions, }, }) => {
        const { age:{ min,max, }, gender, } = conditions;
        const age = [
          !!min && `>${min.inclusive === false ? '' : '='} ${min.value}`,
          !!max && `<${max.inclusive === false ? '' : '='} ${max.value}`,
        ].filter(condition => !!condition).join(' and ');

        return {
          id,
          gender: gender.eq.value,
          age,
        };
      });
    },
  },

  methods: {
    ...mapActions('admin', ['listNormalisationVectors', 'listConstants',]),
  },
};
</script>
